import Vue from 'vue'
import router from '../router/index'
// VUE COOKIE
import VueCookies from 'vue-cookies'
Vue.use(VueCookies);
// VUE MASK
import VueMask from 'v-mask'
Vue.use(VueMask)

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
Vue.component('v-select', vSelect)

// AXIOS
import Axios from 'axios'
Vue.prototype.$http = Axios
Axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if(error.response.status) {
      if (error.response.status == 401) {
        
        
        if($cookies.get('type_user_login') == 'instance'){
          $cookies.remove("token_instance");
          $cookies.remove("data_instance");
          router.push("/instance/login");
        }else if($cookies.get('type_user_login') == 'group'){
          $cookies.remove("token_group");
          $cookies.remove("data_group");
          router.push("/group/login");
        }else if($cookies.get('type_user_login') == 'admin'){
          $cookies.remove("token_admin");
          $cookies.remove("data_admin");
          router.push("/admin/login");
        }

        setTimeout(() => {
          $cookies.remove("type_user_login");
        }, 300);

        
      }else if(error.response.status == 403){
        console.log(error.response.status);
        router.push("/403");
      } 
      else if(error.response.status == 404){
        router.push("/404");
      }
      else if(error.response.status == 500){
        router.push("/500");
      }
      else {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
)

// VUELIDATE
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)
